import * as React from 'react'
// libs
import styled, { css } from 'styled-components'
import { DropzoneRef } from 'react-dropzone'
// components
import { Scrollbar as ScrollbarOrigin } from 'components/UI'
// view components
import Activity from 'containers/Activities/components/Activity'
import CreateCommentForm from 'components/FormElements/ReduxForm/Forms/CreateCommentForm'
import DateTitle from 'components/Modals/PlanItems/components/ActivitiesList/components/DateTitle'
import ReviewDropzone from 'components/Modals/CreateReviewModal/components/ReviewDetails/components/Dropzone'
// hocs
import { withDropzone } from 'hocs/index'
// context
import { ActivitiesListAPIContext } from 'containers/Activities/layers/API/ActivitiesList'
import { ActivitiesListBLContext } from 'containers/Activities/layers/BL/ActivitiesList'

// styled
export const Scrollbar = styled((props) => <ScrollbarOrigin {...props} />)`
  height: calc(100% - 248px);
  padding: 0 32px 16px 16px;

  ${({ isReviewDetails }) =>
    isReviewDetails &&
    css`
      padding: 0;
      font-size: 14px;
      margin-top: 24px;
    `}
`

const ReviewDropzoneWrapper = styled('div')<{ isReviewView: boolean }>`
  font-size: 18px;
  margin-top: 12px;
  padding: ${({ isReviewView }) => (isReviewView ? 0 : '16px 8px')};
`

// types
interface IIncomingProps {
  open: DropzoneRef
}

const ActivitiesListContent: React.FunctionComponent<IIncomingProps> = ({ open }) => {
  const { entity, logs, refetch } = React.useContext(ActivitiesListAPIContext)
  const { isReviewView, isReviewDetails, shouldShowLogs, shouldShowCommentForm } =
    React.useContext(ActivitiesListBLContext)

  return (
    <>
      {isReviewDetails && (
        <>
          <ReviewDropzoneWrapper isReviewView={isReviewView}>Attachments & Links</ReviewDropzoneWrapper>
          {!isReviewView && <ReviewDropzone disableCover entity={entity} refetch={refetch} />}
        </>
      )}

      {!isReviewDetails && shouldShowCommentForm && <CreateCommentForm open={open} />}
      <Scrollbar isReviewDetails={isReviewDetails}>
        {shouldShowLogs &&
          logs.map((item) => {
            return item.map((component) => {
              if (Array.isArray(component)) {
                return component.map((log) => {
                  return <Activity key={log.id} activity={log} />
                })
              }
              return !isReviewDetails ? <DateTitle key={component} date={component} /> : null
            })
          })}
      </Scrollbar>
    </>
  )
}

export default withDropzone(ActivitiesListContent)
